export const CLASS_NAME = 'cst-search-input'
